import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdSponsorBannerComponent} from '@components/ad-campaign/components/ad-sponsor-banner/ad-sponsor-banner.component';
import {LibUtilsPipesModule} from '@utils/pipes/lib-utils-pipes.module';
import {MatIconModule} from '@angular/material/icon';
import { ShowAdBannerPipe } from './pipes/show-ad-banner.pipe';
import {LibLazyImageModule} from '@components/image/modules/lazy-image/lib-lazy-image.module';

@NgModule({
  imports: [
    CommonModule,
    LibUtilsPipesModule,
    MatIconModule,
    LibLazyImageModule,
  ],
  declarations: [
    AdSponsorBannerComponent,
    ShowAdBannerPipe,
  ],
  exports: [
    AdSponsorBannerComponent,
  ]
})
export class LibAdCampaignModule { }
